import React from "react";
import Newsletter1 from "../components/Newsletters/Newsletter1";
import Newsletter2 from "../components/Newsletters/Newsletter2";

const Resources = () => {
  return (
    <div className="flex w-full flex-col items-stretch">
      <Newsletter1 />
      <Newsletter2 />
    </div>
  );
};

export default Resources;
